import { render, staticRenderFns } from "./vLoader.vue?vue&type=template&id=0e583ce7"
import script from "./vLoader.vue?vue&type=script&lang=js"
export * from "./vLoader.vue?vue&type=script&lang=js"
import style0 from "./vLoader.vue?vue&type=style&index=0&id=0e583ce7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports